import { createSignal } from 'solid-js';

export type ToastActivityEntryT = {
  id: number;
  type: string;
  title?: string;
  message: string;
  href?: string;
  linkText?: string;
  at: Date;
  unread: boolean;
};

const MAX_ACTIVITY_ENTRIES = 50;

const [entries, setEntries] = createSignal<ToastActivityEntryT[]>([]);
const [unreadCount, setUnreadCount] = createSignal(0);

let nextEntryId = 0;

export const toastActivityEntries = entries;
export const toastActivityUnreadCount = unreadCount;

export const recordToastActivity = (entry: {
  type: string;
  title?: string;
  message: string;
  href?: string;
  linkText?: string;
}) => {
  const next: ToastActivityEntryT = {
    ...entry,
    id: (nextEntryId += 1),
    at: new Date(),
    unread: true,
  };
  let droppedUnread = 0;
  setEntries((prev) => {
    const combined = [next, ...prev];
    droppedUnread = combined
      .slice(MAX_ACTIVITY_ENTRIES)
      .filter((item) => item.unread).length;
    return combined.slice(0, MAX_ACTIVITY_ENTRIES);
  });
  setUnreadCount((count) => Math.max(0, count + 1 - droppedUnread));
};

export const markToastActivitySeen = () => {
  setUnreadCount(0);
  setEntries((prev) =>
    prev.some((entry) => entry.unread)
      ? prev.map((entry) =>
          entry.unread ? { ...entry, unread: false } : entry,
        )
      : prev,
  );
};

export const dismissToastActivity = (id: number) => {
  const target = entries().find((entry) => entry.id === id);
  if (target === undefined) {
    return;
  }
  setEntries((prev) => prev.filter((entry) => entry.id !== id));
  if (target.unread) {
    setUnreadCount((count) => Math.max(0, count - 1));
  }
};

export const clearToastActivity = () => {
  setEntries([]);
  setUnreadCount(0);
};
